export default __webpack_public_path__ + "static/media/light.d98d6a7c.svg";